module.exports = __webpack_public_path__ + "ecomondo_news-foto-5.jpg?fbb8997edc743d4e5b7e941a6311cf62";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ecomondo_news-foto-5.jpg
// module id = 184
// module chunks = 0